import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';

import { StyledOnBoardCard } from './HomeOnboardPetolo.styled';

const OnboardCard = ({ titleHtml, bodyText, children }) => {
  return (
    <StyledOnBoardCard>
      <Typography variant="h1" dangerouslySetInnerHTML={{ __html: titleHtml || '' }} />
      {children}

      <Typography variant="p">{bodyText || ``}</Typography>
    </StyledOnBoardCard>
  );
};

OnboardCard.propTypes = {
  titleHtml: PropTypes.string,
  bodyText: PropTypes.string,
  children: PropTypes.node,
};

export default OnboardCard;
